import { X } from "lucide-react";
import { editorColors as colors, fonts } from "../../styles/theme";

export default function CtaButtonModal({
  ctaModal,
  setCtaModal,
  ctaPages,
  editor,
}) {
  if (!ctaModal) return null;

  return (
    <div
      style={{
        position: "fixed", inset: 0, zIndex: 9999,
        background: "rgba(0,0,0,0.6)", display: "flex",
        alignItems: "center", justifyContent: "center",
      }}
      onClick={() => setCtaModal(null)}
    >
      <div
        style={{
          background: colors.bgCard, borderRadius: 10,
          width: "min(90vw, 400px)", padding: 24,
          boxShadow: "0 20px 60px rgba(0,0,0,0.4)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ fontFamily: fonts.heading, fontSize: 16, fontWeight: 700, color: colors.text, margin: 0 }}>
            Insert CTA Button
          </h3>
          <button
            onClick={() => setCtaModal(null)}
            style={{ background: "none", border: "none", cursor: "pointer", color: colors.textSecondary, padding: 4 }}
          >
            <X size={16} />
          </button>
        </div>

        {/* Button text */}
        <label style={{ fontSize: 12, color: colors.textSecondary, display: "block", marginBottom: 4 }}>
          Button text
        </label>
        <input
          type="text"
          value={ctaModal.label}
          onChange={(e) => setCtaModal((p) => ({ ...p, label: e.target.value }))}
          placeholder="Register Now"
          style={{
            width: "100%", padding: "8px 10px", fontSize: 13,
            border: `1px solid ${colors.border}`, borderRadius: 6,
            background: colors.bg, color: colors.text,
            boxSizing: "border-box", marginBottom: 14,
          }}
        />

        {/* Link type toggle */}
        <label style={{ fontSize: 12, color: colors.textSecondary, display: "block", marginBottom: 6 }}>
          Link to
        </label>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          {[
            { id: "url", label: "Custom URL" },
            { id: "form", label: "Landing Page / Form" },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setCtaModal((p) => ({ ...p, linkType: t.id, url: "" }))}
              style={{
                flex: 1, padding: "6px 8px", fontSize: 12,
                border: `1px solid ${ctaModal.linkType === t.id ? colors.accent : colors.border}`,
                borderRadius: 6, cursor: "pointer",
                background: ctaModal.linkType === t.id ? `${colors.accent}18` : colors.bg,
                color: ctaModal.linkType === t.id ? colors.accent : colors.textSecondary,
                fontWeight: ctaModal.linkType === t.id ? 600 : 400,
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* URL input or page selector */}
        {ctaModal.linkType === "url" ? (
          <input
            type="url"
            value={ctaModal.url}
            onChange={(e) => setCtaModal((p) => ({ ...p, url: e.target.value }))}
            placeholder="https://"
            style={{
              width: "100%", padding: "8px 10px", fontSize: 13,
              border: `1px solid ${colors.border}`, borderRadius: 6,
              background: colors.bg, color: colors.text,
              boxSizing: "border-box", marginBottom: 14,
            }}
          />
        ) : (
          <div style={{ marginBottom: 14 }}>
            {ctaPages === null ? (
              <div style={{ fontSize: 12, color: colors.textSecondary, padding: "8px 0" }}>
                Loading pages...
              </div>
            ) : ctaPages.length === 0 ? (
              <div style={{ fontSize: 12, color: colors.textSecondary, padding: "8px 0" }}>
                No published landing pages found. Create one in Content Pages first.
              </div>
            ) : (
              <select
                value={ctaModal.url}
                onChange={(e) => setCtaModal((p) => ({ ...p, url: e.target.value }))}
                style={{
                  width: "100%", padding: "8px 10px", fontSize: 13,
                  border: `1px solid ${colors.border}`, borderRadius: 6,
                  background: colors.bg, color: colors.text,
                  boxSizing: "border-box",
                }}
              >
                <option value="">Select a landing page...</option>
                {ctaPages.map((p) => (
                  <option key={p.id} value={`${window.location.origin}/api/page/${p.slug}`}>
                    {p.title}
                  </option>
                ))}
              </select>
            )}
            {ctaModal.url && (
              <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 4, wordBreak: "break-all" }}>
                {ctaModal.url}
              </div>
            )}
          </div>
        )}

        {/* Insert button */}
        <button
          onClick={() => {
            const url = ctaModal.url?.trim();
            const label = ctaModal.label?.trim();
            if (!label) { alert("Button text is required."); return; }
            if (!url) { alert("Please enter a URL or select a landing page."); return; }
            editor.chain().focus().setCtaButton({ label, url }).run();
            setCtaModal(null);
          }}
          style={{
            width: "100%", padding: "10px 16px", fontSize: 14,
            fontWeight: 600, border: "none", borderRadius: 6,
            background: colors.accent, color: colors.text,
            cursor: "pointer",
          }}
        >
          Insert Button
        </button>
      </div>
    </div>
  );
}
